export const EVERY_TIME = 'EVERY_TIME';
export const JUST_ONCE = 'JUST_ONCE';
